module.exports = __webpack_public_path__ + "static/media/dustin.9c958999.png";